<!--
 * @Description: 弹窗模块
 * @Autor: lwq
 * @Date: 2020-08-15 14:42:46
 * @LastEditors: Please set LastEditors
 * @LastEditTime: 2021-01-19 17:57:43
 * @FilePath: \mrc-base-server-view\src\views\data-access-strategy\modules\viewDataOfSubordinates\dialogModule.vue
-->
<template>
  <mrc_ess_myDialog :isopen="isopen"
                    @cancel="cancel"
                    @success="success"
                    @flag="flag"
                    width="50vw"
                    :title="title"
                    :disabled="true">
    <div style="overflow-x: hidden;">
      <!-- <mrc_ess_switch :true-value="1"
                      v-if="$store.state.uuid"
                      :false-value="0"
                      :readonly="readonly"
                      v-model="params.status"
                      :label="params.status == 1 ? $t('label_To_enable_the') : $t('label_disable')">
      </mrc_ess_switch> -->
      <mrc_ess_staffInfo defaultRequest
                         item-value="staff_id"
                         v-model="params.staff_uuid"
                         :errorMessages="$errors('params', 'staff_uuid', requiredRule)"
                         :readonly="readonly"
                         filter="1,2,3,5"
                         :label="$t('label_Employee_name')+ '*'">
      </mrc_ess_staffInfo>
      <mrc_ess_autoComplete :label="$t('label_Viewed_organization') + '*'"
                            :readonly="readonly"
                            multiple
                            deptView
                            :errorMessages="$errors('params', 'org_level_uuids', requiredRule)"
                            v-model="params.org_level_uuids"
                            :prompt_name="dept_uuid"></mrc_ess_autoComplete>

      <!-- :errorMessages="$errors('params', 'exclude_staff_uuids', requiredRule)" -->
      <mrc_ess_staffInfo v-model="params.exclude_staff_uuids"
                         defaultRequest
                         filter="1,2,3,5"
                         item-value="staff_id"
                         :readonly="readonly"
                         :label="$t('label_Exclude_people')"
                         :multiple="true">
      </mrc_ess_staffInfo>
      <!-- :error-messages="$errors('params', 'exclude_function_uuids', requiredRule)" -->
      <tree v-model="params.exclude_function_uuids"> </tree>
      <!-- <div :error-messages="$errors('params', 'exclude_function_uuids', requiredRule)"
           style="font-size:12px;color:rgb(255, 82, 82);position:relative;top:-15px;">
        {{ $errors('params', 'exclude_function_uuids', requiredRule)[0] }}
      </div> -->
    </div>
  </mrc_ess_myDialog>
</template>

<script>
import { required } from 'vuelidate/lib/validators'
import tree from '../tree.vue'
export default {
  components: { tree },
  props: {
    title: {
      type: String,
    },
    readonly: {
      type: Boolean,
      default: false,
    },
    isopen: {
      type: Boolean,
      default: false,
    },
    paramsData: {
      type: Object,
      default: () => {
        return {}
      },
    },
  },
  model: {
    prop: 'isopen',
    event: 'flag',
  },
  data () {
    return {
      params: {},
      type: 0, // 0新增 1修改
    }
  },
  validations: {
    params: {
      staff_uuid: {
        required,
      },
      org_level_uuids: {
        required,
      },
      exclude_staff_uuids: {
        // required,
      },
      exclude_function_uuids: {
        // required,
      },
    },
  },
  computed: {
    dept_uuid () {
      return {
        prompt_name: 'levelUuid_deptUuid',
        org_level_uuid: this.$store.state.currentCompany,
      }
    },
  },
  created () { },
  watch: {
    paramsData (v) {
      if (Object.keys(v).length > 0) this.type = 1
      else this.type = 0
      this.params = this.$clone(v)
      // if (v.status) {
      //   this.params = this.$clone(v)
      // } else {
      //   this.params = { ...this.$clone(v), status: 1, high_grade_switch: 1 }
      // }
    },
  },
  mounted () {
    this.params = this.$clone(this.paramsData)
    if (Object.keys(this.params).length > 0) this.type = 1
    else this.type = 0
    // if (this.$clone(this.paramsData).status) {
    //   this.params = this.$clone(this.paramsData)
    // } else {
    //   this.params = {
    //     ...this.$clone(this.paramsData),
    //     status: 1,
    //     high_grade_switch: 1,
    //   }
    // }
  },

  methods: {
    cancel () {
      this.$emit('flag', !this.isopen)
      this.$emit('cancel')
    },
    success () {
      this.$v.params.$touch()
      if (this.$v.params.$error) return
      this.$emit('getData', this.params, this.type)
      this.$emit('flag', !this.isopen)
    },
    flag () {
      this.$v.params.$reset()
    },
  },
}
</script>

<style scoped></style>
